export const kamon_addresses = {
  decoderAddress:"0xAa37fA6cEb855500E269513cA9e6E5F13B4D0D95",
  kamonAddress:"0x94A44de106112A761B69dFBEB1ac6cfdD1B80304"
}
